import React from "react";
import "./App.css";
import "./Components/LoginSignUp.css";
import Login from "./Components/Login";
import SignUP from "./Components/SignUP";
import Home from "./Components/Home";
import Requirements from "./Components/Requirements";
import MyPosts from "./Components/MyPosts";
import AllPosts from "./Components/AllPosts";
import AskLawyer from "./Components/AskLawyer";
import MyQueries from "./Components/MyQueries";
import { UserAuthContextProvider } from "./Context/UserAuthContext";
import ProtectedRoutes from "./Components/ProtectedRoutes";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return (
    <>
      <UserAuthContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Login/>}/>
            <Route path='/signup' element={<SignUP/>}/>
            <Route path='/home' element={<ProtectedRoutes><Home/></ProtectedRoutes>}/>
            <Route path='/requirements' element={<ProtectedRoutes><Requirements/></ProtectedRoutes>}/>
            <Route path='/my-posts' element={<ProtectedRoutes><MyPosts/></ProtectedRoutes>}/>
            <Route path='/all-posts' element={<ProtectedRoutes><AllPosts/></ProtectedRoutes>}/>
            <Route path='/ask-lawyer' element={<ProtectedRoutes><AskLawyer/></ProtectedRoutes>}/>
            <Route path='/my-queries' element={<ProtectedRoutes><MyQueries/></ProtectedRoutes>}/>
          </Routes>
        </Router>
      </UserAuthContextProvider>
    </>
  );
}

export default App;
